import { NgModule } from '@angular/core';
import { TwentyFourHoursToAmPmPipe } from './twentyFourHoursToAmPm.pipe';

@NgModule({
  declarations: [TwentyFourHoursToAmPmPipe],
  exports: [TwentyFourHoursToAmPmPipe],
})
export class TwentyFourHoursToAmPmPipeModule {}
